import type { EventView } from '@koto-event/shared';

interface Props {
  event: EventView;
  onStart: () => void;
  disabled?: boolean;
}

/**
 * イベント TOP（フロー図「イベントTOP」）。
 * TOP 画像・イベントタイトル・イベント説明・参加ボタンは管理画面から登録する。
 */
export function EventTopScreen({ event, onStart, disabled }: Props): JSX.Element {
  const { screens } = event;

  return (
    <div className="stack">
      {screens.topImageUrl && <img className="hero-image" src={screens.topImageUrl} alt="" />}
      <div className="card">
        <h1>{screens.topTitle || event.name}</h1>
        <p>{screens.topBody || event.description}</p>
        {event.locationName && <p className="muted">{event.locationName}</p>}
      </div>

      {event.prizes.length > 0 && (
        <div className="card">
          <h2>賞品</h2>
          <div className="stack">
            {event.prizes.map((p) => (
              <div key={p.id} className="coupon">
                {p.imageUrl && (
                  <img src={p.imageUrl} alt="" width={56} height={56} style={{ borderRadius: 8 }} />
                )}
                <div>
                  <div style={{ fontWeight: 700 }}>{p.name}</div>
                  <div className="muted">{p.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <button type="button" className="btn" onClick={onStart} disabled={disabled}>
        参加する
      </button>
    </div>
  );
}
